module.exports = __webpack_public_path__ + "static/img/tx.db812c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tx.png
// module id = a6V4
// module chunks = 0